/**
 * This file is part of Zeus Apollon
 *
 * This model represents a Zeus Dokument entity.
 *
 * (c) Kaden und Partner AG
 */
import { BaseModel } from '@/models/BaseModel'
import type { MutationsObject } from '@kp/js-model'
import dayjs, { Dayjs } from 'dayjs'

export class ZeusDokument extends BaseModel {
    public id: number | null = null
    public beschreibung: number | null = null
    public erstellt_am: Dayjs | null = null
    public bearbeitet_am: Dayjs | null = null
    public name: string | null = null
    public filename: string | null = null
    public gesuch_id: number | null = null
    public mime: string | null = null
    public orig_filename: string | null = null

    public mutations(): MutationsObject {
        return {
            id: (id: number) => (Number(id) > 0 ? Number(id) : null),
            erstellt_am: dayjs,
            bearbeitet_am: dayjs,
        }
    }

    getClassName(): string {
        return 'dokument'
    }
}
